export const commonActions = {
    SEARCH_PROP: "SEARCH_PROP",
    LAT_LONG: "LAT_LONG",
    OPEN_LOGIN: "OPEN_LOGIN",
};
